import {
  TemplateValidatorIssue,
  TemplateValidatorResponseItem,
} from "../data-model/templateValidatorModel";

/**
 * Maps validator API results to issue lists keyed by each item's `report_identifier`.
 *
 * The validate request may omit rows with empty `template_text`, so the response array
 * is not guaranteed to align by index with the full modal payload. Each
 * {@link TemplateValidatorResponseItem} echoes `report_identifier` from the filtered request,
 * so we key off the response only.
 *
 * @param results - `results` from a successful template-validator response
 * @returns Issues merged in order per `report_identifier` when multiple rows share it
 */
export function buildWritebackQcMapFromValidation(
  results: TemplateValidatorResponseItem[],
): Record<string, TemplateValidatorIssue[]> {
  const out: Record<string, TemplateValidatorIssue[]> = {};

  for (const result of results) {
    const issues = result.parsed_content?.issues_present ?? [];
    if (issues.length === 0) continue;

    const reportId = result.report_identifier;
    if (!out[reportId]) {
      out[reportId] = [];
    }
    out[reportId] = [...out[reportId], ...issues];
  }

  return out;
}
